import {NotifyEnum} from "./notifyEnum.js"

/**
 * 訊息類型
 * @enum {MessageType}
 */
export enum MessageType {
  /**
   * 主持人離線
   */
  SpeakerOffline = NotifyEnum.SessionStatusOffAir,
  /**
   * 主持人上線
   */
  SpeakerOnline = NotifyEnum.SessionStatusOnAir,
  /**
   * 一般訊息
   */
  TranscriptMessage = 'transcriptMessage'
}
